import { render } from "./ResidentContact.vue?vue&type=template&id=0437853f"
import script from "./ResidentContact.vue?vue&type=script&lang=js"
export * from "./ResidentContact.vue?vue&type=script&lang=js"

import "./ResidentContact.vue?vue&type=style&index=0&id=0437853f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__